/* Watchlist chips. Lives in this browser only - same contract as the prototype.
   The chip sits inside the card anchor, so the click is intercepted before the
   browser follows the link. */
(function () {
  var watch = (window.tanxWatch && window.tanxWatch.load()) || new Set();

  function paint(el) {
    var id = el.getAttribute('data-watch');
    var on = watch.has(id);
    el.setAttribute('data-on', on ? 'true' : 'false');
    if (el.classList.contains('chip')) {
      el.innerHTML = on ? '&#9829;' : '&#9825;';
      if (el.closest('.product-media-bar')) el.innerHTML = on ? '&#9829; Watching' : '&#9825; Watch';
    } else {
      el.textContent = on ? 'Remove from watchlist' : 'Add to watchlist';
    }
    el.setAttribute('aria-label', on ? 'Remove from watchlist' : 'Add to watchlist');
  }

  function paintAll() {
    document.querySelectorAll('[data-watch]').forEach(paint);
    var c = document.getElementById('watchCount');
    if (c) c.textContent = watch.size;
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-watch]');
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    var id = chip.getAttribute('data-watch');
    if (watch.has(id)) watch.delete(id); else watch.add(id);
    if (window.tanxWatch) window.tanxWatch.save(watch);
    paintAll();
    document.dispatchEvent(new CustomEvent('tanx:watch'));
  });

  paintAll();
})();